// Copyright (c) 2022, Comsearch, Inc., All rights reserved

import moment from 'moment-timezone'
import { hide } from 'react-notification-system-redux'
import { SYSTEM_MAINTENANCE_WARNING_NOTIFICATION } from '../constants'
import applicationIsWithinMaintenanceMode from './applicationIsWithinMaintenanceMode'
import getTimeUntilMaintenanceEnds from './getTimeUntilMaintenanceEnds'
import getTimeUntilMaintenanceStarts from './getTimeUntilMaintenanceStarts'
import setApplicationMaintenanceWarningNotification from './setApplicationMaintenanceWarningNotification'

/**
 * calls toggleMaintenanceWindow after the current period is over.
 * This will recursively call itself each time the period changes
 * to being the next timeout until the change of the period.
 * @param {Function} toggleMaintenanceWindow
 */
const handleApplicationMaintenanceWindow = toggleMaintenanceWindow => dispatch => {
  const currentMomentInEastern = moment(Date.now()).tz('America/New_York')

  const maintenanceModeActive = applicationIsWithinMaintenanceMode(currentMomentInEastern)

  const timeUntilNextWindow = (
    maintenanceModeActive
      ? getTimeUntilMaintenanceEnds(currentMomentInEastern)
      : getTimeUntilMaintenanceStarts(currentMomentInEastern)
  )

  if (!maintenanceModeActive) {
      dispatch(setApplicationMaintenanceWarningNotification(timeUntilNextWindow))
  }

  setTimeout(() => {
    toggleMaintenanceWindow()
    dispatch(hide(SYSTEM_MAINTENANCE_WARNING_NOTIFICATION))
    dispatch(handleApplicationMaintenanceWindow(toggleMaintenanceWindow))
  }, timeUntilNextWindow)
}

export default handleApplicationMaintenanceWindow
